// Module
var code = "<md-content class=\"animated fadeIn\"> <div ng-style=\"{height: $ctrl.screenSize.height + 'px'}\" layout=\"column\" layout-align=\"center center\"> <h2>Unsupported Browser</h2> <p> Please install the latest version of <a href=\"https://www.google.com/chrome/browser/desktop/\" target=\"_blank\">Chrome</a> </p> </div> </md-content>";
// Exports
export default code;